import React, { Component, Fragment } from 'react'
import queryString from 'query-string'
import { Card, CardBody, Alert, CardFooter } from 'reactstrap'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { BeatLoader } from 'react-spinners'
import { 
  DownloadCSVs,
  // ErrorsDownload,
  InfoConfirmation, 
  ProcessButton,
  ProgressDiv,
  UploadInput,
  VerifyButton,
  VerifyResultsTable,
} from './UploadCSVComponents'

/**
 * View for uploading a csv of student data for a school on this route:
 * /assessment/upload/school/
 */

class UploadCSV extends Component {
  render() {
    const { 
      assessment,
      district, 
      linkToBackups,
      linkToUsernameCSVs,
      loading, 
      loadingError, 
      processedStudents,
      processing,
      school, 
      status,
      studentErrors,
      totalStudents,
      uploadData,
      uploadError,
      verifying,
      verifyWarnings,
      verifyErrors,
      verified,
      handleUpload, 
      handleVerify,
      handleProcess,
      location, 
      studentsCSV,
      teachersCSV,
      uploadedDataBool,
      usernameCSVsReady,
    } = this.props
    const query = queryString.parse(location.search)
    const schoolYear = query.sy
    return (
      <Card>
        {!loading && !loadingError && 
          <Fragment>
            <CardBody>
              <h2>Upload TruScore Data CSV</h2>
              <InfoConfirmation 
                school={school.name}
                district={district.name}
                schoolYear={schoolYear}
                assessment={assessment.displayName}
              />
              <UploadInput 
                handleUpload={handleUpload}
                uploadData={uploadData}
                uploadError={uploadError}
              />
              <VerifyButton 
                handleVerify={handleVerify}
                verifying={verifying}
                dataUploaded={uploadedDataBool}
              />
              {' '}
              <ProcessButton 
                handleProcess={handleProcess}
                verified={verified}
                verifyErrors={verifyErrors}
                processing={processing}
              />
              <ProgressDiv 
                processedStudents={processedStudents}
                status={status}
                totalStudents={totalStudents}
              />
              <DownloadCSVs
                school={school.name}
                studentsCSV={studentsCSV}
                teachersCSV={teachersCSV}
                usernameCSVsReady={usernameCSVsReady}
              />
              <VerifyResultsTable 
                verifyWarnings={verifyWarnings}
                verifyErrors={verifyErrors}
                verifying={verifying}
              />
              {/* <ErrorsDownload 
                // hasStudentErrors={hasStudentErrors}
                studentErrors={studentErrors}
              /> */}
            </CardBody>
            <CardFooter>
              <Link to={linkToUsernameCSVs}>Username CSVs</Link>
              {' | '}
              <Link to={linkToBackups}>Restore Backups</Link>
            </CardFooter>
          </Fragment>
        }
        <BeatLoader loading={loading} color={'#00C1AB'} />
        {loadingError &&
          <Alert>Error loading school, district, and asssessment data.</Alert>
        }

      </Card>
    )
  }
}

const { object, string, bool, func, number, array } = PropTypes

UploadCSV.propTypes = {
  assessment: object,
  district: object,
  handleProcess: func,
  handleUpload: func,
  handleVerify: func,
  linkToBackups: string,
  linkToUsernameCSVs: string,
  loading: bool,
  loadingError: string,
  location: object,
  processedStudents: number,
  processing: bool,
  school: object,
  status: string,
  studentErrors: array,
  studentUsernames: bool,
  teacherUsernames: bool,
  toggleUsernameOptions: func,
  totalStudents: number,
  uploadData: array,
  uploadedDataBool: bool.isRequired,
  uploadError: string,
  verified: bool,
  verifyErrors: object,
  verifyWarnings: object,
  verifying: bool,
}

export default UploadCSV


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSV.js